"use strict";

exports.__esModule = true;

exports.default = function (target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    // 从第二个参数开始
    var source = arguments[i] || {}; // 获取该对象
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        // 只处理不是从原型链上继承来的属性
        var value = source[prop];
        if (value !== undefined) {
          target[prop] = value; // 覆盖
        }
      }
    }
  }

  return target;
};

; /**
   * 合并对象
   * @param {Object} target 要合并到的对象
   * @returns {Object} 合并后的新对象
   */


//////////////////
// WEBPACK FOOTER
// ./node_modules/hui/lib/utils/merge.js
// module id = eosI
// module chunks = 1